"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoNumberSprite = void 0;
const NumberSprite_1 = require("../NumberSprite");
const InfoType_1 = require("./InfoType");
const InfoSprite_1 = require("./InfoSprite");
const Animation_1 = require("../Animation/Animation");
const numberList = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map(x => x.toString());
class InfoNumberSprite extends NumberSprite_1.NumberSprite {
    constructor(info, textures) {
        super(numberList.map(x => textures[x]));
        this.infoSprites = [];
        this.animation = new Animation_1.AnimationManager();
        this.update = (dt) => {
            if (!this.visible)
                return;
            this.animation.update(dt);
            for (const x of this.infoSprites) {
                x.update(dt);
            }
        };
        if (info.fontSize !== undefined)
            this.fontSize = info.fontSize;
        if (info.fontTint !== undefined)
            this.tint = parseInt(info.fontTint.replace("#", "0x"));
        if (info.fontPadding !== undefined)
            this.padding = info.fontPadding;
        InfoType_1.setPositionInfo(this, info.position);
        this.animation.propSetter = Animation_1.CreatePixiPropSetter(this);
        if (info.animations instanceof Object) {
            for (const prop in info.animations) {
                this.animation.animations.set(prop, info.animations[prop]);
            }
        }
        if (info.children instanceof Array) {
            for (const x of info.children) {
                const c = new InfoSprite_1.InfoSprite(x, textures);
                this.addChild(c);
                this.infoSprites.push(c);
            }
        }
    }
    resetAnim() {
        this.animation.currentTime = 0;
        for (const x of this.infoSprites) {
            x.resetAnim();
        }
    }
    allAnimEnd() {
        if (!this.animation.ended)
            return false;
        for (const x of this.infoSprites) {
            if (!x.allAnimEnd())
                return false;
        }
        return true;
    }
}
exports.InfoNumberSprite = InfoNumberSprite;
//# sourceMappingURL=InfoNumberSprite.js.map